import { useState, useEffect, useContext } from "react";
import { ShopContext } from "../../../config/shopContext";
import {
  useLazyGetFilteredShopsQuery,
  useGetShopCategoriesQuery,
} from "../../../features/shop/shopApiSlice";

export const useBuyWholesellerState = () => {
  const shopType = "wholesellerShop";
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [shopCategorytwo, setShopCategorytwo] = useState();

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);

  const [filters, setFilters] = useState(currentData.additionalData || {
    shopname: "", shopCategory: "", marketPlace: "", shopid: "",
    specialoffer: "", sale: "", itemname: "", categoryid: "",
    subCategoryid: "", country: "", state: "", city: "",
    salespromotion: "", min: "", max: ""
  });

  // Pagination states
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 15;
  const [currentFilterMethod, setCurrentFilterMethod] = useState("shop");

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters(prev => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  useEffect(() => {
    executeFilter("shop", 1, filters);
  }, []);

  // RTK Queries
  const { data: createshopcategoryRes } = useGetShopCategoriesQuery({
    type: "wholesellerShop",
    parentCategory: "",
  });
  const createshopcategory = createshopcategoryRes?.data?.Category;

  const { data: shopCategoryRes } = useGetShopCategoriesQuery({
    type: "wholesellerShop",
    parentCategory: "true",
  });
  const shopCategory = shopCategoryRes?.data?.Category;

  const { data: shopCategorytwoRes } = useGetShopCategoriesQuery(
    { type: "wholesellerShopItem", parentCategory: categoryName },
    { skip: !categoryName }
  );

  const Mydata = () => {
    if (shopCategorytwoRes?.data?.Category) {
      setShopCategorytwo(shopCategorytwoRes.data.Category);
    }
  };

  const [triggerFilter, { data: filterResult, isLoading, isFetching }] = useLazyGetFilteredShopsQuery();

  useEffect(() => {
    if (filterResult?.success) {
      setShopdata(filterResult.Shop || []);
      setItemmdata(filterResult.ShopItem || []);
      setTotalPages(filterResult.totalPages || 1);
      updateFilteredData(shopType, filterResult.Shop || [], filterResult.ShopItem || [], filters);
    }
  }, [filterResult]);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => { setShowshare(true); setShowmodal(false); };

  const Handledata = (e) => {
    setDataCategory(prev => ({
      ...prev,
      [e.target.name]: e.target.value.split(".")
    }));
  };

  const Handleadditioanalshop = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const executeFilter = async (method, pageNum = 1, overrideFilters = null) => {
    setCurrentFilterMethod(method);
    setPage(pageNum);

    // Build the query object
    const query = {
      businessType: "wholesellerShop",
      filtermethod: method,
      page: pageNum,
      limit,
    };

    const keys = method === "shop"
      ? ["shopname", "shopCategory", "marketPlace", "shopid", "specialoffer", "sale"]
      : ["itemname", "categoryid", "subCategoryid", "country", "state", "city", "specialoffer", "salespromotion", "min", "max"];

    const activeFilters = overrideFilters || filters;

    const ignoreValues = [
      "Shop Category", "Sale", "Special Offer", "Category",
      "Select Sub Category", "Select country", "Select state", "Select city"
    ];

    keys.forEach(k => {
      const val = activeFilters[k];
      if (val && typeof val === 'string' && val.trim() !== "" && !ignoreValues.includes(val.trim())) {
        query[k] = val.trim();
      }
    });

    try {
      await triggerFilter(query).unwrap();
    } catch (err) {
      console.error("Filter failed:", err);
    }
  };

  const FilterHandler = () => {
    const newFilters = { ...filters, itemname: "", categoryid: "", subCategoryid: "", country: "", state: "", city: "", salespromotion: "", min: "", max: "" };
    setFilters(newFilters);
    executeFilter("shop", 1, newFilters);
  };

  const FilterHandleritem = () => {
    const newFilters = { ...filters, shopname: "", shopCategory: "", marketPlace: "", shopid: "", specialoffer: "", sale: "" };
    setFilters(newFilters);
    executeFilter("shopitem", 1, newFilters);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      executeFilter(currentFilterMethod, newPage);
    }
  };

  return {
    isloading: isLoading || isFetching,
    createshopcategory,
    shopCategory,
    shopCategorytwo,
    showmodal,
    showshare,
    dataCategory,
    shopdata,
    itemmdata,
    filters,
    page,
    totalPages,
    handleClosemodal,
    handleShow,
    handleCloseshare,
    handleShowshare,
    Handledata,
    Mydata,
    Handleadditioanalshop,
    FilterHandler,
    FilterHandleritem,
    handlePageChange
  };
};
